import ApiService from "@/services/api.service";
import { Capacitor } from "@capacitor/core";

const ATTRIBUTION_KEYS = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content",
    "utm_id",
    "gclid",
    "fbclid",
    "ttclid",
    "msclkid",
    "li_fat_id",
];

let captured = false;

export function useAttribution() {
    async function captureFromUrl(): Promise<void> {
        if (captured) {
            return;
        }
        if (Capacitor.getPlatform() !== "web") {
            return;
        }
        if (typeof window === "undefined" || !window.location?.search) {
            return;
        }

        const params = new URLSearchParams(window.location.search);
        const properties: Record<string, string> = {};

        for (const key of ATTRIBUTION_KEYS) {
            const value = params.get(key);
            if (value !== null && value !== "") {
                properties[key] = value.slice(0, 255);
            }
        }

        if (Object.keys(properties).length === 0) {
            return;
        }

        properties.landing_path = window.location.pathname.slice(0, 255);
        properties.referrer = (document.referrer || "").slice(0, 255);

        captured = true;

        try {
            await ApiService.post("/t", {
                type: "attribution.touched",
                properties,
            });
        } catch {
            captured = false;
        }
    }

    return { captureFromUrl };
}
